<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_black_friday_2025.jpg" style="width: 100%" />
    <p class="tituloTarjeta">¡BLACK FRIDAY EN TUS SEGUROS!</p>
    <p>
      Contrata <b>AHORA</b> y llévate un <b>20% de DESCUENTO</b> en tu Seguro de <b>COCHE, HOGAR o NEGOCIO</b>.
    </p>
   
    
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar
        </button>
      </a>
    </p>

  </div>
</template>

<script>
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
